import React from 'react'
import * as styles from 'pages/home/Logos.module.scss'

import { BandSlider } from 'components/BandSlider'

const images = [
  '/img/home/band/ajax.png',
  '/img/home/band/colgate.png',
  '/img/home/band/cp.png',
  '/img/home/band/fabuloso.png',
  '/img/home/band/hello.png',
  '/img/home/band/irish-spring.png',
  '/img/home/band/murphy.png',
  '/img/home/band/palmolive.png',
  '/img/home/band/softsoap.png',
  '/img/home/band/speed-stick.png',
  '/img/home/band/suavitel.png',
  '/img/home/band/toms.png',
]

const Logos = () => {
  return (
    <div className={styles.logosContainer}>
      <BandSlider images={images} />
    </div>
  )
}

export default Logos
